import { j as d } from "./jsx-runtime-3tyXYecC.mjs";
import { u as M } from "./use-readable-context-BO-ExsvT.mjs";
import { a as N, M as _ } from "./masked-input-UstFy78I.mjs";
import { l as k } from "./lodash-5ofSKtz3.mjs";
import { forwardRef as E, useState as w, useRef as g, useEffect as y } from "react";
import { m as T } from "./tss-DN0acMKN.mjs";
import { T as V } from "./text-button-yPCa43NP.mjs";
const F = {
  employeeSsn: {
    mask: "000-00-0000"
  },
  employeeSin: {
    mask: "000-000-000"
  },
  employeeNin: {
    mask: "aa aa aa aa a",
    definitions: {
      a: /[\w\d]/
    }
  },
  employeeNationalId: {
    mask: "######[##########]",
    definitions: {
      "#": /[\w\d]/
    }
  },
  validatePassportNumber: {
    mask: /^[\w\d]{0,20}$/
  },
  ccExpirationField: {
    mask: "00/00"
  }
};
function I(s, e) {
  const t = F[s] || { mask: /.*/ };
  return e ? [
    t,
    {
      mask: N,
      enum: [e]
    }
  ] : [t];
}
const C = T({ name: "SensitiveTextField" })((s, e, t) => ({
  root: {
    [`&:hover .${t.toggleButton}`]: {
      visibility: "visible"
    },
    [`&:focus-within .${t.toggleButton}`]: {
      visibility: "visible"
    }
  },
  toggleButton: {
    marginTop: "-2px",
    visibility: "hidden"
  }
})), H = window.jQuery ? $.__("Show") : "Show", P = window.jQuery ? $.__("Hide") : "Hide", D = E(
  ({
    className: s,
    disabled: e,
    fieldType: t,
    onChange: h = () => {
    },
    onShow: v,
    note: u,
    value: c,
    sensitiveValue: a,
    MaskOptions: x,
    ...S
  }, b) => {
    const { classes: f, cx: R } = C(), { isReadable: r } = M(), [i, l] = w(!1), [j, p] = w(!1), n = g();
    n.current = v, y(() => {
      r || l(!0);
    }, [r, l]), y(() => {
      i && typeof n.current == "function" && (p(!0), Promise.resolve(n.current()).finally(() => p(!1)));
    }, [i, n]);
    const B = typeof u > "u" && r && a && !e, m = g();
    return m.current = i && !k.isNil(c) ? c : a, /* @__PURE__ */ d.jsx(
      _,
      {
        ...S,
        className: R(f.root, s),
        conformInitialValue: !1,
        disabled: e,
        MaskOptions: {
          ...k.omit(x || {}, "mask"),
          mask: I(t, a),
          onAccept: (o) => {
            m.current !== o && h({ value: o });
          }
        },
        note: B ? /* @__PURE__ */ d.jsx(
          V,
          {
            className: f.toggleButton,
            disabled: e,
            onClick: () => {
              l((o) => !o);
            },
            onFocus: (o) => o.stopPropagation(),
            type: "button",
            children: i && !j ? P : H
          }
        ) : u,
        ref: b,
        submitUnmaskedValue: !0,
        value: m.current
      }
    );
  }
);
export {
  D as S
};
//# sourceMappingURL=sensitive-text-field-CgY8Ts9P.mjs.map
